<script setup lang="ts">
import { getLangText } from '@/ts/utils/utils.ts';
import PromoIcon from "./assets/promo.svg?raw";
import { navigateTo } from '@/ts/management/view-navigation-management';
import model from '@/ts/model';
import { isNavViewItemActive } from './mobile-nav-bottom';
</script>

<template>
    <div class="nav-item" @click.prevent.stop="navigateTo('promos')" :class="{active: isNavViewItemActive('promos')}">
        <div class="icon">
            <span v-html="PromoIcon"></span>
        </div>
        <div class="name">{{ getLangText('Promos', undefined, 'mobile-nav-bottom') }}</div>
    </div>
</template>

<style lang="scss" scoped>
@use './nav-item.scss';
</style>